module.exports = function () {
    var $brightCoveVideos = $('.video-modal .video-js');
    if ($brightCoveVideos.length > 0) {
        var $videoModals = $('.video-modal');
        var videoIndex = 1;
        $videoModals.each(function () {
            // instantiate video objects. The videojs() method can only take in an ID, so give an ID to each video in order to pass it in and instantiate it
            $videoFrame = $(this).find('.video-js')
            $videoFrame.attr('id', 'videoModalIndex' + videoIndex);
            var vidID = $videoFrame.attr('id');
            var videoModalPlayer = videojs(vidID);
            var $videoModalContainer = $(this);
            var $currentVideo = $videoModalContainer.find('.video');

            videoModalPlayer.on('play',
                function () {

                });
            videoModalPlayer.on('pause',
                function () {

                });
            videoModalPlayer.on('ended',
                function () {
                    //videoModalPlayer.poster(videoModalPlayer.poster());
                });

            $('.video-modal').on('hidden.bs.modal',
                function (e) {
                    videoModalPlayer.pause();
                })

            videoIndex++;
        });
    }

    var htmlVideos = $('video');
    if (htmlVideos.length > 0) {
        $('.video-modal').on('hidden.bs.modal',
            function (e) {
                $(this).find('video')[0].pause();
            });

        $('.modal').on('hidden.bs.modal', function (e) {
            $("video").each(function () {
                this.pause()
            });
        });
    }
};